var selectedCommentId = '';
var selectedProjectMessageId = '';

function NewsfeedRefresh() {
	newsfeedResultIndex = 1;
	jQuery('#project-newsfeed').html("<div id='newsfeed-loading'><img src='/i/ajax-loader.gif' alt='Loading...' style='vertical-align: middle;' /><span style='font-weight: bold;vertical-align: middle; padding-left: 6px;'>Loading...</span></div>");

	//PanteraScript.PanteraScriptService.GetProjectNewsfeedAdmin(pjqSessionId, newsfeedResultIndex, newsfeedPageSize, NewsfeedC, onScriptError);
	var xmlFile = '/DesktopModules/PJQProjectWallAdmin/GetNewsfeed.aspx?sessionid=' + pjqSessionId + '&pn=' + newsfeedResultIndex.toString() + '&ps=' + newsfeedPageSize.toString() + '&x=' + (new Date).getTime();

	jQuery.ajax({
		url: xmlFile,
		success: function(result) {
			NewsfeedC(result);
		},
		error: function(xhr, status, error) {
			showInfoDialogPWall('Export Error', "An error occurred during newsfeed generation: " + error, 'ui-icon-alert');
		}
	});

}

function ReplyPrivate(projectContactId) {
	jQuery('#intmessage-context-message').val('');
	jQuery('#intmessage-context-pc').val(projectContactId);
	jQuery('#intmessage-replytext').val('');
	jQuery('#intmessage-conversation').html('');

	jQuery('#intmessage-replytext').removeClass('pjq-errortext');
	jQuery('#intmessage-replytext label.pjq-errortext').remove();

	jQuery('#intmessage-reply').removeClass('pjq-hidden');
	var buttonList = {
		Reply: function() {
			if (!validator.element('#intmessage-replytext')) {
				var obj = {};
				obj['intmessage-replytext'] = 'Message is Required';
				jQuery('#Form').validate().showErrors(obj);
				return false;
			}

			PanteraScript.PanteraScriptService.SendInternalMessage(pjqSessionId, parseInt(jQuery('#intmessage-context-pc').val()), jQuery('#intmessage-replytext').val(), jQuery('#intmessage-context-message').val(), SendIntMessageC, onScriptError);

			$(this).dialog("close");
		}
	};

	var subject = 'Reply Privately';

	var dlg = jQuery("#dialog-intmessage").dialog({
		width: 600,
		modal: true,
		title: subject,
		buttons: buttonList
	});
	dlg.parent().appendTo($("form[name='Form']"));
	return false;
}

function HandleViewProjectMessage(projectMessageId) {
	selectedProjectMessageId = projectMessageId;
	jQuery('#tabsMain').tabs('option', 'active', 2);
	if (gridITBGroupBy != 'view_message')
		InitializeGridITB('view_message');
	else {
		gridITB.selectRowById(selectedProjectMessageId);
		var cell = gridITB.cells(selectedProjectMessageId, 0);
		cell.open();
		selectedProjectMessageId = '';
		setTimeout(function() {
			jQuery(window).scrollTop(jQuery(cell.cell).offset().top);
		}, 10);
	}
}

var isNewsfeedLoading = false;
function PJQProjectWallAdminProjectNewsfeedInitialize() {
	$("#project-newsfeed").scroll(function() {
		if ($("#project-newsfeed").height() > 50) {
			var scrollTop = $("#project-newsfeed").scrollTop();
			if (scrollTop + 25 >= $("#project-newsfeed")[0].scrollHeight - $("#project-newsfeed").height()) {
				if (newsfeedResultCount != -1 && !isNewsfeedLoading) {
					isNewsfeedLoading = true;
					//PanteraScript.PanteraScriptService.GetProjectNewsfeedAdmin(pjqSessionId, newsfeedResultIndex, newsfeedPageSize, NewsfeedC, onScriptError);		  

					var xmlFile = '/DesktopModules/PJQProjectWallAdmin/GetNewsfeed.aspx?sessionid=' + pjqSessionId + '&pn=' + newsfeedResultIndex.toString() + '&ps=' + newsfeedPageSize.toString() + '&x=' + (new Date).getTime();

					jQuery.ajax({
						url: xmlFile,
						success: function(result) {
							NewsfeedC(result);
						},
						error: function(xhr, status, error) {
							showInfoDialogPWall('Export Error', "An error occurred during newsfeed generation: " + error, 'ui-icon-alert');
						}
					});

				}
			}
		}
		return true;
	});

}

function HandleDelete(sender, type) {
	selectedCommentId = jQuery(sender).attr('pjq-parentcommentid');
	if (type == 'ProjectMessage')
		showInfoDialogPWall('Delete Message', 'Are you sure you want to delete this Project Message?', 'ui-icon-alert', 'delete-project-message')

	return false;
}

function HandleCopyMsg(sender) {
	var projectMessageId = jQuery(sender).attr('pjq-projectmessageid');
	CopyProjectMsg(projectMessageId);
	return false;
}

function HandleDeleteC(response) {
	jQuery("div[pjq-auditlog-id='" + selectedCommentId + "']").remove();
}

function DeleteProjectCommentId() {
	PanteraScript.PanteraScriptService.DeleteProjectComment(pjqSessionId, selectedCommentId, HandleDeleteSubC, onScriptError);
}

function DeleteProjectMessageByCommentId(callback) {
	PanteraScript.PanteraScriptService.DeleteProjectMessageByCommentId(pjqSessionId, selectedCommentId, typeof callback ==='function' ? callback : HandleDeleteC, onScriptError);
}

function HandleDeleteSubC(response) {
	jQuery("div[pjq-auditlog-id='" + selectedCommentId + "']").remove();
	if (jQuery("div.newsfeed-subcomment", jQuery("#newsfeed-subcommentlist-" + response)).length == 0) {
		jQuery("#newsfeed-subcommentlist-" + response).parent().hide();
		jQuery("#newsfeed-subcommentlist-" + response).parent().prev().hide();
	} else if (jQuery("div.newsfeed-subcomment-last", jQuery("#newsfeed-subcommentlist-" + response)).length == 0) {
		jQuery("div.newsfeed-subcomment", jQuery("#newsfeed-subcommentlist-" + response)).last().addClass('newsfeed-subcomment-last');
	}
}

function HandleDeleteSub(sender, type) {
	selectedCommentId = jQuery(sender).attr('pjq-parentcommentid');
	if (type == 'ProjectSubCommentGuest' || type == 'ProjectSubCommentUser')
		showInfoDialogPWall('Delete Message', 'Are you sure you want to delete this Comment?', 'ui-icon-alert', 'delete-project-comment')
}

function HandleReplyAll(sender) {
	jQuery('#newsfeed-rta').val('');
	jQuery('#newsfeed-replypublic-context').val(jQuery(sender).attr('pjq-parentcommentid'));
	var dlg = jQuery('#dialog-newsfeed-reply').dialog({
		modal: true,
		title: 'Reply to All',
		width: 500,
		buttons: {
			Send: function() {
				if (HandleReplyAllSend())
					$(this).dialog("close");
			}

		}
	});
	dlg.parent().appendTo($("form[name='Form']"));

	return false;
}

function HandleReplyAllSend() {
	ClearValidationError('#newsfeed-rta');
	if (jQuery('#newsfeed-rta').val().trim().length == 0) {
		SetValidationError('#newsfeed-rta', 'Message is Required');
		return false;
	}

	jQuery('#newsfeed-subcommentlist-' + jQuery('#newsfeed-replypublic-context').val() + ' .newsfeed-subcomment-last').removeClass('newsfeed-subcomment-last');

	PanteraScript.PanteraScriptService.AddProjectCommentAdmin(pjqSessionId, jQuery('#newsfeed-replypublic-context').val(), jQuery('#newsfeed-rta').val(), AddProjectCommentC, onScriptError);

	return true;
}

function AddProjectCommentC(response) {
	var commentResponse = jQuery.parseJSON(response);

	var parentCommentId = commentResponse.AuditLogId;

	var newComment = "<div class='newsfeed-subcomment newsfeed-subcomment-last'>";
	newComment += "<div class='newsfeed-toprow'>";
	newComment += "<img src='{{attr:ProfileLogoImageUrl}}' alt='~formatNewsfeedName(Text)' class='newsfeed-image' />";
	newComment += "<span class='newsfeed-name'>{{>~formatNewsfeedName(Text)}}</span> <span class='newsfeed-prefix'>said:</span>";
	newComment += "</div><div class='newsfeed-body'>{{:~formatNewsfeed(Text)}}</div>";
	newComment += "<span class='newsfeed-time'>{{>~formatDate(CreatedOn)}}</span></div>";
	var newCommentTemplate = $.templates(newComment);

	jQuery('#newsfeed-subcommentlist-' + parentCommentId).append(newCommentTemplate.render(commentResponse));
	jQuery('#newsfeed-subcommentlist-' + parentCommentId).show();
	jQuery('#newsfeed-subcommentlist-' + parentCommentId).parent().show();
	jQuery('#newsfeed-subcommentlist-' + parentCommentId).parent().prev().show();


}

function CancelReplyAll(sender) {
	jQuery('.newsfeed-commentreply').css('display', 'none');
	if (jQuery('.newsfeed-subcomments').val().length == 0)
		jQuery('.newsfeed-subcomments', jQuery(sender).parent().parent()).css('display', 'none');

	jQuery(this.parent.parent).focus();
	return false;
}